import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { Bank } from "@shared/enums/bank-type.enum";
import { FractionationTypes } from "@shared/enums/fractionation-types";
import { FractionationTypeLabel } from "@shared/enums/fractionationTypeLabel.type";
import { PolicyFields } from "@shared/enums/policy-fields.enum";
import {
    getDropdownClass,
    getInputClass,
    getInputMaskClass,
    getIsEditable,
    getIsVisible,
    IbanValidator,
} from "@shared/helpers/contract-edition.helper";
import { Member } from "@shared/models/member";
import { PolicyDetail } from "@shared/models/policy-details";
import { PolicyFieldsVM } from "@shared/models/policy-field-vm.model";
import { DropdownModule } from "primeng/dropdown";
import { InputMaskModule } from "primeng/inputmask";

@Component({
  selector: "app-contract-edition-payment-informations",
  standalone: true,
  imports: [CommonModule, TranslateModule, DropdownModule, FormsModule, InputMaskModule],
  templateUrl: "./contract-edition-payment-informations.component.html",
})
export class ContractEditionPaymentInformationsComponent implements OnInit {
  @Input() policyFieldsVM!: PolicyFieldsVM;
  @Input() policyDetails!: PolicyDetail;
  @Input() policyDetailsCopy!: PolicyDetail;
  @Input() fractionationOptions!: { label: string; value: FractionationTypes; code: string }[];
  @Input() memberCopy!: Member;
  @Input() hasEndorsementWait4Sign!: boolean;
  @Output() emitFormValidity = new EventEmitter<number>();
  @Output() emitOnPaymentIbanBlur = new EventEmitter();
  PolicyFields = PolicyFields;
  FractionationTypesLabel = FractionationTypeLabel;
  Bank = Bank;
  isIbanValid = true;

  getIsVisible = getIsVisible;
  getIsEditable = getIsEditable;
  getInputClass = getInputClass;
  getDropdownClass = getDropdownClass;
  getInputMaskClass = getInputMaskClass;

  paymentDateAllOptions = [
    { label: "Le 5 du mois", value: "5" },
    { label: "Le 10 du mois", value: "10" },
    { label: "Le 15 du mois", value: "15" },
  ];

  paymentDateOptions = [
    { label: "Le 5 du mois", value: "5" },
    { label: "Le 10 du mois", value: "10" },
    { label: "Le 15 du mois", value: "15" },
  ];

  paymentOwnerHasChanged = false;
  paymentFractionationHasChanged = false;
  paymentCollectionDateHasChanged = false;
  paymentIbanHasChanged = false;
  paymentMethodHasChanged = false;

  ngOnInit(): void {
    this.initDateOptions();
    this.refreshHasChanged();
  }

  initDateOptions() {
    this.paymentDateOptions = this.paymentDateAllOptions.filter(collectionDay => this.policyDetails.bankInformationPolicyVm.validWithdrawalDays.includes(collectionDay.value))
  }

  onPaymentMethodChange() {
    this.paymentMethodHasChanged =
      this.policyDetailsCopy.bankInformationPolicyVm.receiptPaymentType !==
      this.policyDetails.bankInformationPolicyVm.receiptPaymentType;
  }

  onPaymentOwnerChange() {
    this.paymentOwnerHasChanged =
      this.policyDetailsCopy.bankInformationPolicyVm.owner !== this.policyDetails.bankInformationPolicyVm.owner;
  }

  onPaymentFractionationChange() {
    this.paymentFractionationHasChanged =
      this.policyDetailsCopy.bankInformationPolicyVm.fractionationTypeLabel !==
      this.policyDetails.bankInformationPolicyVm.fractionationTypeLabel;
    if (
      this.policyDetailsCopy.bankInformationPolicyVm.fractionationTypeLabel === FractionationTypeLabel.Monthly &&
      this.policyDetailsCopy.bankInformationPolicyVm.withdrawalDay === "-"
    ) {
      this.policyDetailsCopy.bankInformationPolicyVm.withdrawalDay = "5";
    }
    if (this.policyDetailsCopy.bankInformationPolicyVm.fractionationTypeLabel === FractionationTypeLabel.Annual) {
      this.policyDetailsCopy.bankInformationPolicyVm.withdrawalDay = "-";
    }
  }

  onPaymentCollectionDateChange() {
    this.paymentCollectionDateHasChanged =
      this.policyDetailsCopy.bankInformationPolicyVm.withdrawalDay !==
      this.policyDetails.bankInformationPolicyVm.withdrawalDay;
  }

  onPaymentIbanBlur() {
    this.isIbanValid = IbanValidator(this.policyDetailsCopy.bankInformationPolicyVm.iban);
    if (!this.paymentIbanHasChanged || !this.isIbanValid) {
      return;
    }
    this.emitOnPaymentIbanBlur.emit();
  }

  onPaymentIbanChange() {
    this.isIbanValid = IbanValidator(this.policyDetailsCopy.bankInformationPolicyVm.iban);
    this.paymentIbanHasChanged =
      this.policyDetailsCopy.bankInformationPolicyVm.iban !== this.policyDetails.bankInformationPolicyVm.iban;
    this.emitFormValidity.emit(0);
  }

  refreshHasChanged() {
    this.paymentMethodHasChanged =
      this.policyDetailsCopy.bankInformationPolicyVm.receiptPaymentType !==
      this.policyDetails.bankInformationPolicyVm.receiptPaymentType;
    this.paymentOwnerHasChanged =
      this.policyDetailsCopy.bankInformationPolicyVm.owner !== this.policyDetails.bankInformationPolicyVm.owner;
    this.paymentFractionationHasChanged =
      this.policyDetailsCopy.bankInformationPolicyVm.fractionationTypeLabel !==
      this.policyDetails.bankInformationPolicyVm.fractionationTypeLabel;
    this.paymentCollectionDateHasChanged =
      this.policyDetailsCopy.bankInformationPolicyVm.withdrawalDay !==
      this.policyDetails.bankInformationPolicyVm.withdrawalDay;
    this.paymentIbanHasChanged =
      this.policyDetailsCopy.bankInformationPolicyVm.iban !== this.policyDetails.bankInformationPolicyVm.iban;
  }
}
